import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { config, config_init } from "./config/config";
import { setDefaultOptions, loadCss } from "esri-loader";

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.config.productionTip = false;

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

async function loadConfig() {
  await config_init();
  console.log(config);
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
loadConfig();

setDefaultOptions({ css: true, version: "3.35" });
